import type { BankAccount } from '@repo/api-contracts';
import { type ReactElement, useState } from 'react';
import { Button } from '@/shared/ui';
export const BankAccountCopyRow = ({ bank }: { readonly bank: BankAccount }): ReactElement => {
  const [message, setMessage] = useState<string | null>(null);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(bank.account);
      setMessage('계좌번호를 복사했습니다.');
    } catch {
      setMessage('복사하지 못했습니다. 계좌번호를 직접 복사해 주세요.');
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-3">
      <span>
        {bank.bank} {bank.account} {bank.holder}
      </span>
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          void copy();
        }}
      >
        복사
      </Button>
      {message ? <p role="status">{message}</p> : null}
    </div>
  );
};
